// components/shared/AdBanner.tsx
'use client'

import Image from 'next/image';
import { Card } from '../../../../components/ui/card';

interface AdBannerProps {
  imageUrl: string;
  linkUrl: string;
  altText: string;
  className?: string;
}

export default function AdBanner({ imageUrl, linkUrl, altText, className }: AdBannerProps) {
  return (
    <Card className={`overflow-hidden bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-lg shadow-lg dark:bg-gradient-to-br dark:from-slate-800/50 dark:via-slate-700/60 dark:to-slate-800/50 dark:backdrop-blur-sm dark:border dark:border-slate-700 ${className}`}>
      <a href={linkUrl} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
        {/*
          Используйте ваш реальный путь к изображению.
          Для демо я просто использую заглушку. В реальном проекте,
          если баннер динамический, он может быть получен из БД или CMS.
        */}
        <Image
          src={imageUrl}
          alt={altText}
          width={1200} // Адаптируйте под размер вашего баннера
          height={200} // Адаптируйте под размер вашего баннера
          layout="responsive" // Делает изображение адаптивным
          objectFit="cover"
          className="w-full h-auto"
          priority // Загружать баннер с высоким приоритетом, если он важный
          onError={(e) => {
            e.currentTarget.src = 'https://placehold.co/1200x200?text=Рекламный+Баннер';
            e.currentTarget.alt = 'Ошибка загрузки баннера';
            e.currentTarget.onerror = null;
          }}
        />
      </a>
    </Card>
  );
}